import useCartController from 'hooks/use-cart-controller';
import useFeatureFlagsController from 'hooks/use-feature-flags-controller';
import useUserController from 'hooks/use-user-controller';
import useUIController from 'hooks/use-ui-controller';
import useSearchPreferencesController from 'hooks/use-search-preferences-controller';
import usePurchaseLimitsFlagsController from 'hooks/use-purchase-limits-flags-controller';
import useCheckoutWidgetOnKioskFlagController from 'hooks/use-checkout-widget-on-kiosk-flag-controller';
import useSessionContextCookieController from 'hooks/use-session-context-cookie-controller';
import { usePhoneVerificationNudgeController } from 'src/hooks/use-phone-verification-nudge-controller';

export default function GlobalControllers() {
  useCartController();
  useFeatureFlagsController();
  useUserController();
  useUIController();
  useSearchPreferencesController();
  usePurchaseLimitsFlagsController();
  useCheckoutWidgetOnKioskFlagController();
  useSessionContextCookieController();
  usePhoneVerificationNudgeController();
  return null;
}
